
/**
 * CLIENT firebase app instance
 */

// Import the functions you need from the SDKs you need
import { getAnalytics, isSupported } from "firebase/analytics";
import { getApp, getApps, initializeApp } from "firebase/app";
// TO-DO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
    apiKey: "AIzaSyB-IHQ4ds42ApRENWBbGhyXqxgG5X1CVTw",
    authDomain: "nightfall-site.firebaseapp.com",
    projectId: "nightfall-site",
    storageBucket: "nightfall-site.firebasestorage.app",
    messagingSenderId: "33217981239",
    appId: "1:33217981239:web:694dfcc9e18bceeba2c8b2",
    measurementId: "G-526B524F20"
};

// Initialize Firebase
const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

(async () => {
    if (global.window && (await isSupported()))
        getAnalytics(firebaseApp);
})()

export default firebaseApp;
